import {
  SearchAlienationRecuperationEtatBienFluxDto,
  SearchFluxUsingGETQueryParamsSortDto,
} from 'lib_api/lib/api/gen';

import {
  TablePagination,
  TableSort,
} from 'components/WrappedComponents/Table/types';

import { FilterDashboardFlux } from '../../types';
import { SearchAlienationResponse } from '../shared/types';
import { useSearchFluxsAlienation } from '../shared/utils';

import { FluxVenteDossiersSortType } from './types';

export function useSearchFluxsRecuperationEtatBien(
  _: FilterDashboardFlux,
  sorts: TableSort<FluxVenteDossiersSortType>,
  pagination: TablePagination,
): SearchAlienationResponse<SearchAlienationRecuperationEtatBienFluxDto> {
  return useSearchFluxsAlienation<
    SearchAlienationRecuperationEtatBienFluxDto,
    SearchFluxUsingGETQueryParamsSortDto,
    FluxVenteDossiersSortType
  >(
    sorts,
    pagination,
    controller => controller.searchFluxEtatBienUsingGET.bind(controller),
    sorts => {
      return {
        dateAppel: sorts?.DATE_APPEL,
        dateDebut: sorts?.DATE_DEBUT,
        dateFin: sorts?.DATE_FIN,
      };
    },
  );
}
